// Keep Shopify's native consent controls; reserve the bar's measured height.
(() => {
  let banner;
  let frame;
  const updateSpace = () => {
    const height = banner?.isConnected ? Math.ceil(banner.getBoundingClientRect().height) : 0;
    document.documentElement.style.setProperty('--cappture-consent-height', `${height}px`);
  };
  const resize = new ResizeObserver(updateSpace);
  const findBanner = () => {
    const next = document.getElementById('shopify-pc__banner');
    if (next !== banner) {
      resize.disconnect();
      banner = next;
      if (banner) resize.observe(banner);
    }
    updateSpace();
  };
  const mutations = new MutationObserver(() => {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(findBanner);
  });
  mutations.observe(document.body, { childList: true, subtree: true });
  findBanner();
})();
